import cognitoService from './cognitoService';

const authService = {
  login: async (credentials) => {
    return cognitoService.login(credentials);
  },

  logout: async () => {
    return cognitoService.logout();
  },

  getCurrentUser: async () => {
    return cognitoService.getCurrentUser();
  },

  getIdToken: async () => {
    return cognitoService.getIdToken();
  },
};

export default authService;
